import { Observable, combineLatest } from 'rxjs';

import { RGBImage2, GrayImage2 } from './image';

import { map } from 'rxjs/operators';

export function applyColormapObservable(
  image: Observable<GrayImage2>,
  colormap: Observable<Colormap>
) {
  return combineLatest(image, colormap).pipe(
    map((x) => applyColormap(x[0], x[1]))
  );
}
export function imageMinMax(
  image: GrayImage2,
  min: number,
  max: number
): GrayImage2 {
  const nbPixels = image.meta.shape.x * image.meta.shape.y;
  for (let i = 0; i < nbPixels; i++) {
    image.data[i] = Math.max(Math.min(image.data[i], max), min);
  }
  return image;
}

export function applyColormap(image: GrayImage2, colormap: Colormap) {
  const nbPixels = image.meta.shape.x * image.meta.shape.y;
  const r = new Uint8Array(nbPixels);
  const g = new Uint8Array(nbPixels);
  const b = new Uint8Array(nbPixels);
  for (let i = 0; i < nbPixels; i++) {
    r[i] = colormap.r(image.data[i]);
    g[i] = colormap.g(image.data[i]);
    b[i] = colormap.b(image.data[i]);
  }
  return new RGBImage2(
    image.meta.center,
    image.meta.size,
    image.meta.shape,
    r,
    g,
    b
  );
}

export interface Colormap {
  readonly name: string;
  r(x: number): number;
  g(x: number): number;
  b(x: number): number;
}

export namespace Colormaps {
  function truncate(x: number) {
    return Math.max(Math.min(x, 1), 0);
  }
  export const GRAY: Colormap = {
    name: 'gray',
    r: (x: number) => truncate(x) * 255,
    g: (x: number) => truncate(x) * 255,
    b: (x: number) => truncate(x) * 255,
  };

  const greenThreshold = 0.3671875;
  const blueThreshold = 0.7460938;

  export const HOT: Colormap = {
    name: 'hot',
    r(x: number) {
      const c = truncate(x);
      if (c < greenThreshold) {
        return (c / greenThreshold) * 255;
      }
      return 255;
    },
    g(x: number) {
      const c = truncate(x);
      if (c < blueThreshold) {
        if (c > greenThreshold) {
          return ((c - greenThreshold) / (blueThreshold - greenThreshold)) * 255;
        }
        return 0;
      }
      return 255;
    },
    b(x: number) {
      const c = truncate(x);
      if (c < blueThreshold) {
        return 0;
      }
      return ((c - blueThreshold) / (1.0 - blueThreshold)) * 255;
    },
  };
}
